import { render, staticRenderFns } from "./CopyFromAutomation.vue?vue&type=template&id=1db2487a&scoped=true"
import script from "./CopyFromAutomation.vue?vue&type=script&lang=js"
export * from "./CopyFromAutomation.vue?vue&type=script&lang=js"
import style0 from "./CopyFromAutomation.vue?vue&type=style&index=0&id=1db2487a&prod&lang=scss&scoped=true"
import style1 from "./CopyFromAutomation.vue?vue&type=style&index=1&id=1db2487a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2487a",
  null
  
)

export default component.exports